<!--
    Component Sponsor
    @author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="container">
		<div class="content">
			<div class="bar darkText largeText">
				<div class="gridLabel bg-sponsor">{{ model.getDictionary('nav_sponsor')}}</div>
			</div>
			<div class="link-grid">
				<link-tile v-for="link in links" :key="link.seq" :link="link"></link-tile>
			</div>
			<div class="bar darkText largeText">
				<div class="gridLabel bg-sponsor">Spenden</div>
			</div>
			<div>
				<p>
				Der virtuelle Kunstraum Wallis ist ein wichtiger Bestandteil für die Bewahrung des Walliser Kulturerbes, der Walliser Kunstszene und der Kunstvermittlung. 
				Der Verein virtueller Kunstraum Wallis bedankt sich herzlich für Ihre Unterstützung!			
				</p>

				<p style='margin-top: 1rem;'>Bankverbindung:<br>
				IBAN CH12 0076 5001 0343 8221 0<br>
				Verein virtueller Kunstraum Wallis/Espace virtuel d'art Valais<br>
				3900 Brig
				</p>

				<div class='twint'>
				<div><img src='./../assets/twint.png'></div>
				<div id="rnw-paylink-button"></div>
				<script type="module">
				import {PaylinkButton} from "https://donate.raisenow.io/button.js";
				PaylinkButton.render('#rnw-paylink-button', {'solution-id': "jxztt", 'solution-type': "donate", language: "de", size: "large", width: "fixed", 'color-scheme': "dark"})
				</script>
				</div>
			</div>	
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import { model } from "./../model/Model.js";

	const LinkTile = Vue.component("link-tile", {
		props: ["link"],
		template: `<a class='link-tile' :href="link.link" target='_BLANK' >{{ link.label }}</a>`
	});

	export default {
		components: { LinkTile },

		data: function() {
			return {
				// expose the model for translations
				model: model,
				// list of links
				links: model.blockSponsor
			};
		}
	};
</script>

<style>

div.twint {
	margin-top: 3rem;
	display: flex;
	flex-direction: row;
}

div.twint>div {
	margin-right: 3rem;
}

@media (min-width: 1000px) {

	div.gridRight {
		margin-left: 45rem;
	}

	div.link-grid {
		column-count: 2;
		padding-bottom: 2rem;
	}

	a.link-tile {
		display: block;
/*		text-align: right;*/
		padding-right: 2rem;
		margin-bottom: 2rem;
	}

}

@media (max-width: 1000px) {

	a.link-tile {
		display: block;
/*		text-align: right;*/
		padding-right: 2rem;
		margin-bottom: 2rem;
	}
	
}

</style>